import { api } from "./api";
import { fetchAuthSession } from "aws-amplify/auth";

api.interceptors.request.use(async (config) => {
  const session = await fetchAuthSession();

  const accessToken = session.tokens?.accessToken?.toString();

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});
